import { FileRejection } from 'react-dropzone';
import { FILE_SIZE_10MB } from 'modules/api/constants';
import { ACCEPTED_FILE_TYPE_XLS } from 'constants/fileType';
import FileUpload from 'lib/FileUpload';
import { CUSTOM_POI_MAX_FILES } from '../consts';

interface CustomPOIUploadProps {
  onFileChange: (acceptedFiles: File[], rejectedFiles: FileRejection[]) => Promise<void>;
  hasReachedFileUploadLimit: boolean;
}

const CustomPOIUpload: React.FC<CustomPOIUploadProps> = ({ onFileChange, hasReachedFileUploadLimit }) => {
  return (
    <div className="mb-2" data-test-id="custom-poi-upload">
      <FileUpload
        onFileChange={onFileChange}
        acceptFileType={ACCEPTED_FILE_TYPE_XLS}
        maxFileSize={FILE_SIZE_10MB}
        isDisabled={hasReachedFileUploadLimit}
        isMultiple={false}
        isFileUploadButton
        maxFileUploads={CUSTOM_POI_MAX_FILES}
      />
    </div>
  );
};

export default CustomPOIUpload;
